import { Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';
import * as Styled from '../LoyaltyPageReport.styles';

interface ConfirmationDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  sku: string;
}

const ConfirmationDeleteModal = ({
  open,
  onClose,
  onDelete,
  sku,
}: ConfirmationDeleteModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Styled.ConfirmationDeleteModal>
        <div className="title">
          {t('LoyaltyPageReport.ConfirmationDeleteModal.TITLE')} {sku} ?
        </div>
        <div className="buttons-block">
          <button className="button-delete" onClick={onDelete} type="button">
            Да
          </button>
          <button className="button-cancel" onClick={onClose} type="button">
            Нет
          </button>
        </div>
      </Styled.ConfirmationDeleteModal>
    </Modal>
  );
};

export default ConfirmationDeleteModal;
